


















import { Component, Vue, Prop} from "vue-property-decorator";
import { Getter ,Action} from "vuex-class";
@Component({
  components: {

  }
})
export default class DistributeParticipant extends Vue {
  @Getter("section") section!: object;
  @Getter("distributePurchaseList") distributePurchaseList! : Array<object>;
  showParticipantModal(){
    this.$emit('showParticipantModal')
  }
}
